import React from "react";
import { motion, useReducedMotion } from "framer-motion";

// Scroll-triggered reveal
export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduce ? { opacity: 0 } : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </motion.div>
  );
};

const lineParent = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.12, delayChildren: 0.15 } },
};
const lineChild = {
  hidden: { y: "110%" },
  visible: { y: "0%", transition: { duration: 0.9, ease: [0.16, 1, 0.3, 1] } },
};

// Masked line-by-line reveal for hero headings
export const MaskedHeading = ({ lines, className = "" }) => {
  const reduce = useReducedMotion();
  if (reduce) {
    return (
      <h1 className={className}>
        {lines.map((l, i) => (
          <span key={i} className="block">{l}</span>
        ))}
      </h1>
    );
  }
  return (
    <motion.h1
      className={className}
      variants={lineParent}
      initial="hidden"
      animate="visible"
    >
      {lines.map((l, i) => (
        <span key={i} className="block overflow-hidden">
          <motion.span variants={lineChild} className="block">
            {l}
          </motion.span>
        </span>
      ))}
    </motion.h1>
  );
};
